import { HubItemCategoryModel } from "client/Api/Hub/hub";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { useMemo } from "react";

export function useCanOpenHubManagement(
	categories: OptionalModel<readonly HubItemCategoryModel[]>,
	hubItemKindsCanCreateNewCategoriesFor: readonly HubItemKind[],
	canAccessHubManagementForCommunities: boolean
): boolean {
	return useMemo(
		(): boolean => {
			if (!categories.isSet) {
				return false;
			}

			if (canAccessHubManagementForCommunities
				|| hubItemKindsCanCreateNewCategoriesFor.length > 0
			) {
				return true;
			}

			return categories.value
				.some((x) => x.canCreateItem);
		},
		[
			canAccessHubManagementForCommunities,
			categories,
			hubItemKindsCanCreateNewCategoriesFor
		]
	);
}
